import { Obstacle } from "../Obstacle";
import { MovingObsMapData } from "./MovingObsMapData";
import { MovingObsSettings } from "./MovingObsSettings";
import { eObstacleType } from "../ObstacleTypes";
import { ViewCellMapRow } from "../../View/ViewCellMapRow";
import { TileBase } from "../../Ground Tiles/TileBase";
import { MapRow } from "../../Game Map/MapRow";
import { Player } from "../../Player/Player";
import { GameWorld } from "../../GameWorld";
import { SoundManager } from "../../../../Utils/SoundManager";
import { eSfxSprite, SfxSprites, Game, eAudioAsset } from "../../../../Game";



export class MovingObs extends Obstacle {
    private _mapData: MovingObsMapData;
    private _settings: MovingObsSettings;

    /**
     * Minimalni lokalni pozice prekazky na ose X
     */
    private _minX: number;

    /**
     * Maximalni lokalni pozice prekazky na ose X
     */
    private _maxX: number;

    /**
     * Lokalni pozice na ose X pri dosazeni pozice hrace
     */
    private _targetX: number;

    private _oldX: number;
    private _newX: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        super(eObstacleType.moving);

        SoundManager.createSoundComponent(this._entity, {
            positional: true,
            distanceModel: pc.DISTANCE_LINEAR,
            maxDistance: 10
        });

        SoundManager.addSoundSlot(this._entity, eSfxSprite.rollingObstacle, SfxSprites[eSfxSprite.rollingObstacle], Game.sfxSpriteAssetId);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    init(mapData: MovingObsMapData, row: ViewCellMapRow): void {
        super.init(mapData, row);

        this._mapData = mapData;
        this._settings = mapData.settings as MovingObsSettings;

        // Vypocitat min a max horizontalni pozici prekazky
        this.calculateMinMaxX();

        // Nastavit pozici prekazky
        this.setPosition();
        this._oldX = this._newX;

        SoundManager.playSound(this._entity, eSfxSprite.rollingObstacle);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    release(): void {
        this._entity.sound.stop(eSfxSprite.rollingObstacle);
        super.release();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): boolean {
        if (!super.update()) {
            this._entity.sound.stop(eSfxSprite.rollingObstacle);
            return false;
        }

        // Aktualizovat pozici prekazky
        this.setPosition();

        // Rotace
        if (this._settings.rotationSpeed != 0) {
            this._entity.rotateLocal(0, 0, ((this._newX - this._oldX) / this._settings.moveSpeed) * this._settings.rotationSpeed)
        }

        return true;
    }

    //-------------------------------------------------------------------------
    /**
     * Vypocita minimalni a maximalni pozici prekazky na ose X v ramci pc.GraphNode radky
     */
    //-------------------------------------------------------------------------
    private calculateMinMaxX(): void {
        let settings = this._mapData.settings as MovingObsSettings;

        // Min X
        let cellId = 0;

        while (!this._row.getCell(cellId))
            cellId++;

        this._minX = settings.hMargin + cellId * TileBase.SIZE;

        // Max X
        while (cellId < MapRow.WIDTH && this._row.getCell(cellId))
            cellId++;

        this._maxX = cellId * TileBase.SIZE - settings.hMargin;

        // Cilova pozice na ose X
        this._targetX = this._minX + (this._maxX - this._minX) * this._mapData.targetPosRatio;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private setPosition(): void {
        let mapData = this._mapData;
        let settings = mapData.settings as MovingObsSettings;
        let targetPosReachDir = this._mapData.targetPosReachDir;

        // Vypocitat za kolik vterin hrac dosahne pozice stredu radky
        let pl = Player.instance;
        let pathTime = (pl.position.z - this._row.z) / pl.rollingSpeed;

        // Vypocitat jakou vzdalenost prekazka urazi za dany cas
        let pathLen = settings.moveSpeed * pathTime;

        // Rozsah na ose X, ve kterem se prekazka pohybuje
        let pathRange = this._maxX - this._minX;

        // Vypocitat pozici prekazky    
        let i = Math.abs((targetPosReachDir > 0 ? (this._maxX - this._targetX) : (this._targetX - this._minX)) + pathLen);
        let borderBounceCnt = Math.floor(i / pathRange);    // Kolikrat se prekazka odrazi od okraje
        let borderOffset = i % pathRange;   // Startovni offset od okraje

        if ((targetPosReachDir < 0 && (borderBounceCnt & 1) != 0) || (targetPosReachDir > 0 && (borderBounceCnt & 1) == 0)) {
            i = this._maxX - borderOffset;
        }
        else {
            i = this._minX + borderOffset;
        }

        // Nastavit pozici prekazky
        this._entity.setLocalPosition(i, this._version.y, 0);

        if (this._shadow) {
            let settings = this._version.shadow;

            this._shadow.setLocalPosition(i + settings.offsetX, GameWorld.SHADOW_Y, settings.offsetZ);
        }

        this._oldX = this._newX;
        this._newX = i;
    }
}